module.exports = __webpack_public_path__ + "img/smart-campus.236420a2.jpg";